import { render, staticRenderFns } from "./CalculationListView.vue?vue&type=template&id=0536fffe&scoped=true&"
import script from "./CalculationListView.vue?vue&type=script&lang=ts&"
export * from "./CalculationListView.vue?vue&type=script&lang=ts&"
import style0 from "./CalculationListView.vue?vue&type=style&index=0&id=0536fffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0536fffe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDialog,VDivider,VIcon,VSelect,VSpacer})
